import { generateClient } from 'aws-amplify/api';
import { GraphQLOptionsV6 } from '@aws-amplify/api-graphql';
import { Observable } from 'rxjs';

export interface PagedList<T, TYPENAME> {
  __typename: TYPENAME;
  nextToken?: string | null | undefined;
  items: T[];
  total?: number;
}

export abstract class GenericRepository<T> {
  protected client = generateClient();

  public get(id: string): Promise<T> {
    throw new Error(`Received ${JSON.stringify(id)}, but get not implemented.`);
  }

  public list(
    options?: GraphQLOptionsV6['variables']
  ): Promise<PagedList<T, unknown>> {
    throw new Error(
      `Received ${JSON.stringify(options)}, but list not implemented.`
    );
  }

  public search(
    options: GraphQLOptionsV6['variables']
  ): Promise<PagedList<T, unknown>> {
    throw new Error(
      `Received ${JSON.stringify(options)}, but search not implemented.`
    );
  }

  public save(
    object:
      T | Omit<T, '__typename' | 'id' | 'createdAt' | 'updatedAt' | 'owner'>
  ): Promise<T> {
    throw new Error(
      `Received ${JSON.stringify(object)}, but save not implemented.`
    );
  }

  public update(
    object: T | Omit<T, '__typename' | 'createdAt' | 'updatedAt' | 'owner'>
  ): Promise<T> {
    throw new Error(
      `Received ${JSON.stringify(object)}, but update not implemented.`
    );
  }

  public delete(objectId: string): Promise<void> {
    throw new Error(
      `Received ${JSON.stringify(objectId)}, but delete not implemented.`
    );
  }

  async getGraphQLSubscription(graphQlSubscriptionString: string) {
    return this.client.graphql({
      query: graphQlSubscriptionString,
    }) as Observable<never>;
  }
}
